import React, { Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import {
  isIPSAdministrator,
  isIPSDataCreatorOrAdministrator,
} from '../../utils/UserInfo';
import { Button, Table } from 'antd';
import Spinner from '../Spinner';
import Text from 'antd/lib/typography/Text';
import { tabNamesMap } from '../TabNamesMap';

import dayjs from 'dayjs';
import FileExport from '../FileExport';
import ReactTooltip from 'react-tooltip';
import IpsDTCommentsIcon from 'components/CommentsIcon/IpsDTCommentsIcon';
import './IPSDTProjectList.css';

export default withRouter(function IpsDTProjectsList(props) {
  const { projects, allTab, location, tabView } = props;
  const { onButtonClick } = props;

  const getStatusColor = {
    G: '#55b762',
    // Y: '#d2b16f',
    Y:'#e1ad01',
    R: '#d24448',
  };
  const getProjectHeaderColor = {
    // DT_C: '#bf9000',old color
    DT_C: '#e1ad01',
    DT_P: '#ff9900',
    DT_N: '#D53326',
    DT_D: '#9fc5f8',
    DT_A: '#009e0f',
  };

  const renderEllipsisForProjectData = (dataVals, type) => {
    const convertedArray = dataVals && dataVals?.split(',');
    if (
      convertedArray !== null &&
      convertedArray?.length &&
      convertedArray?.length >= 4
    ) {
      return (
        <>
          <div
            style={{ alignItems: 'left', width: 120 }}
            data-tip
            data-for={'toolTip-' + type}
          >
            {convertedArray
              .slice(0, 3)
              .map((item) => item)
              .join(', ')}
            {' ...'}
          </div>
          <ReactTooltip
            id={'toolTip-' + type}
            place='bottom'
            effect='solid'
            textColor='black'
            backgroundColor='white'
            border={true}
            borderColor='black'
            type='info'
          >
            {convertedArray.map((item) => item).join(', ')}
          </ReactTooltip>
        </>
      );
    } else {
      return <div style={{ alignItems: 'left' }}>{dataVals}</div>;
    }
  };

  const renderEllipsisForProjectDescData = (data, projectData, type) => {
    const convertedArray = data && data.split('|');
    if (
      convertedArray !== null &&
      convertedArray.length &&
      convertedArray.length >= 4
    ) {
      return (
        <>
          {convertedArray.slice(0, 3).map((item, index) => (
            <div
              style={{ alignItems: 'left', width: 270 }}
              data-tip
              data-for={'toolTip-' + type}
            >
              {index + 1}) {item}
              {index === 2 && ' ...'}
            </div>
          ))}
          <ReactTooltip
            id={'toolTip-' + type}
            place='bottom'
            effect='solid'
            textColor='black'
            backgroundColor='white'
            border={true}
            borderColor='black'
            type='info'
          >
            {convertedArray.map((item, index) => (
              <div>
                {index + 1}) {item}
              </div>
            ))}
          </ReactTooltip>
        </>
      );
    } else if (
      convertedArray !== null &&
      convertedArray.length &&
      convertedArray.length > 1
    ) {
      return convertedArray.slice().map((item, index) => (
        <div style={{ alignItems: 'left', width: 270 }}>
          {index + 1}) {item}
        </div>
      ));
    } else {
      return (
        <div style={{ alignItems: 'left', width: 270 }}>
          {data || projectData.projectDescription}
        </div>
      );
    }
  };
  const shouldStationLinkDisable = (project) => {
    //https://jira.aepsc.com/browse/TCHEK-629

    if (project.dtstatus === 'DT_P' ||
    project.dtstatus === 'DT_D') {
      return !isIPSDataCreatorOrAdministrator()
    } else if(project.dtstatus === 'DT_N'){
      return !isIPSAdministrator()
    }
  }
  const renderStationName = (stationName, project) => {
    // return (
    //   <Button
    //     id={'inDevCardEditLink'}
    //     type={'link'}
    //     style={{
    //       height: 'auto',
    //       paddingLeft: '0px',
    //       paddingRight: '0px',
    //       alignItems: 'left',
    //       marignLeft: '0px',
    //     }}
    //     onClick={() => onButtonClick(project)}
    //   >
    //     {stationName || ''}
    //   </Button>
    // );
    // return (
    //   <Button
    //     id={'inDevCardEditLink'}
    //     type={'link'}
    //     style={{
    //       height: 'auto',
    //       paddingLeft: '0px',
    //       paddingRight: '0px',
    //       alignItems: 'left',
    //       marignLeft: '0px',
    //     }}
    //     onClick={() => onButtonClick(project)}
    //   >
    //     {stationName || ''}
    //   </Button>
    // );

    return {
      props: {
        // style: { background: project.activeStatus === 'Y' ? (project.allIPSComplFlag === 'Y' ? '#bf9000' : '#009e0f') : 'red', }

        // style: { background: getProjectHeaderColor[project.dtstatus] },
      },
      children: (
        <Button
          id={'inDevCardEditLink'}
          type={'link'}
          style={{
            height: 'auto',
            paddingLeft: '0px',
            paddingRight: '0px',
            alignItems: 'left',
            marignLeft: '0px',
            // color: '#fff',
          }}
          disabled={
            shouldStationLinkDisable(project)
          }
          onClick={() => onButtonClick(project)}
        >
          <span
            className="station-name"
            >
            {stationName || ''}
          </span>
        </Button>
      ),
    };
    // }
  };

  const columns = [
    {
      title: 'Station Name',
      dataIndex: 'stationName',
      fixed: 'left',
      key: 'stationName',
      sorter: (a, b) => {
        a = a.stationName || '';
        b = b.stationName || '';
        return b.localeCompare(a);
      },
      render: (stationName, project) => renderStationName(stationName, project),
    },

    {
      title: 'Project Description',
      dataIndex: 'projectDescription',
      fixed: 'left',
      key: 'projectDescription',
      render: (projectDescription, projectData) =>
        renderEllipsisForProjectDescData(
          projectDescription,
          projectData,
          'projectDescription'
        ),
      sorter: (a, b) => {
        a = a.projectDescription || '';
        b = b.projectDescription || '';
        return b.localeCompare(a);
      },
    },
    {
      title: 'Construction Start Date',
      dataIndex: 'constructionStartDate',
      key: 'constructionStartDate',
      sorter: (a, b) => {
        a = a.constructionStartDate || dayjs('1900-01-01');
        b = b.constructionStartDate || dayjs('1900-01-01');
        if (dayjs(a).isValid() && dayjs(b).isValid())
          return dayjs(a).unix() - dayjs(b).unix();
        else if (dayjs(a).isValid()) return dayjs(a).unix();
        else if (dayjs(b).isValid()) return dayjs(b).unix();
        else return dayjs(a).unix() - dayjs(b).unix();
      },
    },
    {
      title: 'Checklist Release Date',
      dataIndex: 'tclReleaseDate',
      key: 'tclReleaseDate',
      sorter: (a, b) => {
        a = a.tclReleaseDate || dayjs('1900-01-01');
        b = b.tclReleaseDate || dayjs('1900-01-01');
        if (dayjs(a).isValid() && dayjs(b).isValid())
          return dayjs(a).unix() - dayjs(b).unix();
        else if (dayjs(a).isValid()) return dayjs(a).unix();
        else if (dayjs(b).isValid()) return dayjs(b).unix();
        else return dayjs(a).unix() - dayjs(b).unix();
      },
    },
    {
      title: 'In-Service Date',
      dataIndex: 'inServiceDate',
      key: 'inServiceDate',
      sorter: (a, b) => {
        a = a.inServiceDate || dayjs('1900-01-01');
        b = b.inServiceDate || dayjs('1900-01-01');
        if (dayjs(a).isValid() && dayjs(b).isValid())
          return dayjs(a).unix() - dayjs(b).unix();
        else if (dayjs(a).isValid()) return dayjs(a).unix();
        else if (dayjs(b).isValid()) return dayjs(b).unix();
        else return dayjs(a).unix() - dayjs(b).unix();
      },
    },
    {
      title: 'WO',
      dataIndex: 'workOrder',
      key: 'workOrder',
      render: (workOrderVals) =>
        renderEllipsisForProjectData(workOrderVals, 'workOrder'),
      sorter: (a, b) => {
        a = a.workOrder || '';
        b = b.workOrder || '';
        return b.localeCompare(a);
      },
    },
    {
      title: 'BPID',
      dataIndex: 'bpid',
      key: 'bpid',
      render: (bpidVals) => renderEllipsisForProjectData(bpidVals, 'bpid'),
      sorter: (a, b) => {
        a = a.bpid || '';
        b = b.bpid || '';
        return b.localeCompare(a);
      },
    },
    {
      title: 'MPID',
      dataIndex: 'mpid',
      key: 'mpid',
      render: (mpidVals) => renderEllipsisForProjectData(mpidVals, 'mpid'),
      sorter: (a, b) => {
        a = a.mpid || '';
        b = b.mpid || '';
        return b.localeCompare(a);
      },
    },

    {
      title: 'CCA',
      dataIndex: 'ccaNames',
      key: 'ccaNames',
      render: (ccaNames) => renderEllipsisForProjectData(ccaNames, 'cca'),
      sorter: (a, b) => {
        a = a.ccaNames || '';
        b = b.ccaNames || '';
        return  b.localeCompare(a);
      },
    },
    {
      title: 'LCA',
      dataIndex: 'lcaNames',
      key: 'lcaNames',
      render: (lcaNames) => renderEllipsisForProjectData(lcaNames, 'lca'),
      sorter: (a, b) => {
        a = a.lcaNames || '';
        b = b.lcaNames || '';
        return  b.localeCompare(a);
      },
    },

    {
      title: 'RCA',
      dataIndex: 'rcaNames',
      key: 'rcaNames',
      render: (rcaNames) => renderEllipsisForProjectData(rcaNames, 'rca'),
      sorter: (a, b) => {
        a = a.rcaNames || '';
        b = b.rcaNames || '';
        return b.localeCompare(a);
      },
    },
    {
      title: 'State',
      dataIndex: 'stationState',
      key: 'stationState',
      sorter: (a, b) => {
        a = a.stationState || '';
        b = b.stationState || '';
        return b.localeCompare(a);
      },
    },
    {
      title: 'Station Region',
      dataIndex: 'stationRegion',
      key: 'stationRegion',
      sorter: (a, b) => {
        a = a.stationRegion || '';
        b = b.stationRegion || '';
        return b.localeCompare(a);
      },
    },
    {
      title: 'TFS Station Area',
      dataIndex: 'tfStationArea',
      key: 'tfStationArea',
      sorter: (a, b) => {
        a = a.tfStationArea || '';
        b = b.tfStationArea || '';
        return b.localeCompare(a);
      },
    },
    {
      title: 'TFS P&C Area',
      dataIndex: 'pcArea',
      key: 'pcArea',
      sorter: (a, b) => {
        a = a.pcArea || '';
        b = b.pcArea || '';
        return b.localeCompare(a);
      },
    },
    {
      title: 'Phased Project',
      dataIndex: 'dataTrackerPhaseDetails',
      key: 'dataTrackerPhaseDetails',

      render: (field, project) => {
        return {
          children: (
            <div>
              {project?.dataTrackerPhaseDetails?.length > 1 ? 'Yes' : 'No'}
            </div>
          ),
        };
      },
      sorter: (a, b) => {
        if (a.dataTrackerPhaseDetails) {
          a = a.dataTrackerPhaseDetails?.length > 1 || '';
          b = b.dataTrackerPhaseDetails?.length > 1 || '';
          return b - a;
        }
      },
    },
    {
      title: 'Location Sheet Status',
      dataIndex: ['dataTrackerPhaseDetails', [0]],
      key: ['dataTrackerPhaseDetails', [0], ['locSheetStatus']],
      render: (status, project) => {
        return {
          props: {
            style: { color: getStatusColor[status?.locSheetDue] },
          },
          children: <div>{status?.locSheetStatus}</div>,
        };
      },
      sorter: (a, b) => {
        
if(a.dtstatus === "DT_P" || b.dtstatus === "DT_P"){
  return;
}

        if (a.dataTrackerPhaseDetails) {
          a = a.dataTrackerPhaseDetails[0]?.locSheetStatus || '';
          b = b.dataTrackerPhaseDetails[0]?.locSheetStatus || '';
          return a.localeCompare(b);
        }
      },
    },

    {
      title: 'SE Assets Status',
      dataIndex: ['dataTrackerPhaseDetails', [0]],
      key: ['dataTrackerPhaseDetails', [0], ['seAssetsStatus']],
      render: (status, project) => {
        return {
          props: {
            style: { color: getStatusColor[status?.seAssetsDue] },
          },
          children: <div>{status?.seAssetsStatus}</div>,
        };
      },
      sorter: (a, b) => {

        if(a.dtstatus === "DT_P" || b.dtstatus === "DT_P"){
          return;
        }
        if (a.dataTrackerPhaseDetails) {
          a = a.dataTrackerPhaseDetails[0]?.seAssetsStatus || '';
          b = b.dataTrackerPhaseDetails[0]?.seAssetsStatus || '';
          return a.localeCompare(b);
        }
      },
    },
    {
      title: 'PCE Assets Status',
      dataIndex: ['dataTrackerPhaseDetails', [0]],
      key: ['dataTrackerPhaseDetails', [0], ['pceAssetsStatus']],
      render: (status, project) => {
        return {
          props: {
            style: { color: getStatusColor[status?.pceAssetsDue] },
          },
          children: <div>{status?.pceAssetsStatus}</div>,
        };
      },
      sorter: (a, b) => {
        if(a.dtstatus === "DT_P" || b.dtstatus === "DT_P"){
          return;
        }
        if (a.dataTrackerPhaseDetails) {
          a = a.dataTrackerPhaseDetails[0]?.pceAssetsStatus || '';
          b = b.dataTrackerPhaseDetails[0]?.pceAssetsStatus || '';
          return a.localeCompare(b);
        }
      },
    },
    {
      title: 'Total No. of Assets Expected',
      dataIndex: ['dataTrackerPhaseDetails', [0]],
      key: ['dataTrackerPhaseDetails', [0], ['expectedAssetCnt']],
      render: (status, project) => {
        return {
          props: {
            // style: { color: getStatusColor[status?.pceAssetsDue] },
          },
          children: <div>{status?.expectedAssetCnt}</div>,
        };
      },
      sorter: (a, b) => {
        if(a.dtstatus === "DT_P" || b.dtstatus === "DT_P"){
          return;
        }
        if (a.dataTrackerPhaseDetails) {
          a = a.dataTrackerPhaseDetails[0]?.expectedAssetCnt || '';
          b = b.dataTrackerPhaseDetails[0]?.expectedAssetCnt || '';
          return b - a;
        }
      },
    },
    {
      title: 'Total No. of SE Assets',
      dataIndex: 'noOfSEAssets',
      key: 'noOfSEAssets',
      sorter: (a, b) => {
        a = a.noOfSEAssets || '';
        b = b.noOfSEAssets || '';
        return b - a;
      },
    },
    {
      title: 'Total No. of PCE Assets',
      dataIndex: 'noOfPCEAssets',
      key: 'noOfPCEAssets',
      sorter: (a, b) => {
        a = a.noOfPCEAssets || '';
        b = b.noOfPCEAssets || '';
        return b - a;
      },
    },
    {
      title: 'Total No. of Assets',
      dataIndex: 'noOfAssets',
      key: 'noOfAssets',
      sorter: (a, b) => {
        a = a.noOfAssets || '';
        b = b.noOfAssets || '';
        return b - a;
      },
    },

    {
      title: 'Comments',
      dataIndex: 'comment',
      key: '',
      render: (text, project) => (
        <IpsDTCommentsIcon
          project={project}
          commentGroup={'COMMON'}
          view={'dashboard'}
          comments={[]}
          phase={0}
        />
      ),
    },
  ];
  let removedColumn = [
    // 'CCA',
    // 'LCA',
    // 'RCA',
    'Checklist Release Date',
    'Location Sheet Status',
    'SE Assets Status',
    'PCE Assets Status',
    'Comments',
  ];

  const removedColumnFunction = (columnName) => {
    return !removedColumn.includes(columnName);
  };
  return (
    <Fragment>
      <div className='table-responsive'>
        <Spinner />
        <Table
          id={'projectListTable'}
          className={'table-striped'}
          // columns={columns}
          columns={
            tabView !== 'datatracker_pending'
              ? columns
              : columns.filter((everyColumn) => {
                  return removedColumnFunction(everyColumn.title);
                })
          }
          dataSource={projects}
          pagination={{ showSizeChanger: false, pageSize: 10 }}
          scroll={{ x: 'max-content' }}
        />
      </div>
    </Fragment>
  );
});
